import { render } from "./carDialog.vue?vue&type=template&id=588b396a&scoped=true"
import script from "./carDialog.vue?vue&type=script&lang=js"
export * from "./carDialog.vue?vue&type=script&lang=js"

import "./carDialog.vue?vue&type=style&index=0&id=588b396a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588b396a"]])

export default __exports__